import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'productGroup',
  pure: true
})
export class ProductGroupPipe implements PipeTransform {
  transform(products: any[]): any[] {
    if (!products || products.length === 0) {
      return [];
    }

    // Group products by their base name
    const groupedProducts = new Map<string, any[]>();

    products.forEach(product => {
      if (!product || !product.ProductName) {
        return;
      }
      
      const baseName = this.getBaseProductName(product.ProductName);
      
      if (!groupedProducts.has(baseName)) {
        groupedProducts.set(baseName, []);
      }
      groupedProducts.get(baseName)!.push(product);
    });

    // Convert grouped products to array format
    const result: any[] = [];
    groupedProducts.forEach((productGroup, baseName) => {
      if (productGroup.length === 1) {
        // Single product, no grouping needed - return original product unchanged
        result.push(productGroup[0]);
      } else {
        // Multiple products, create grouped product
        const sortedGroup = productGroup.sort((a, b) => {
          // Sort by pack size (single first, then 3pk, 6pk, etc.)
          const aPack = this.getPackSize(a.ProductName);
          const bPack = this.getPackSize(b.ProductName);
          return aPack - bPack;
        });

        const defaultProduct = sortedGroup[0]; // Use the first product as default
        
        // Create a new object with grouping properties but preserve original product
        const groupedProduct = {
          ...defaultProduct,
          _isGrouped: true,
          _packOptions: sortedGroup,
          _selectedPack: defaultProduct,
          _baseName: baseName,
          // Ensure we have the correct ItemID for navigation
          ItemID: defaultProduct.ItemID
        };
        result.push(groupedProduct);
      }
    });
    return result;
  }

  private getBaseProductName(productName: string): string {
    if (!productName) return '';
    
    // Remove pack size indicators to get base name
    let baseName = productName
      .replace(/\s+\d+pk\s*$/i, '') // Remove "3pk", "6pk", etc.
      .replace(/\s+pack\s*$/i, '') // Remove "pack"
      .trim();
    
    return baseName;
  }

  private getPackSize(productName: string): number {
    if (!productName) return 1;
    
    // Extract pack size from product name
    const packMatch = productName.match(/(\d+)pk/i);
    if (packMatch) {
      return parseInt(packMatch[1], 10);
    }
    
    // Default to 1 for single products
    return 1;
  }
}
